/** 
 Copyright Highway9 Networks Inc. 
 */ 
import "regenerator-runtime";
import React from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store";
import { createRoot } from "react-dom/client";

import { configureFetch } from "./helpers";
configureFetch();

const container = document.getElementById("root");
const root = createRoot(container!);

function WithStore() {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
}

root.render(<WithStore />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
